// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.crossmint",
    name: "Crossmint",
    homepage: "https://www.crossmint.com/",
    image_id: "8ad627ec-cbcd-4878-ec5c-3df588055200",
    app: {
        browser: "https://www.crossmint.com",
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://www.crossmint.com",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://www.crossmint.com",
    },
    desktop: {
        native: null,
        universal: "https://www.crossmint.com",
    },
};
//# sourceMappingURL=index.js.map